//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchDetail, fetchUpdate } from '@/api/PMS/customerService/returnVisit';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: ['keyValue', 'flowNum', 'showDialog', 'isDetail'],
  data: function data() {
    return {
      childData: {
        visitRating: '99'
      },
      satisfiedOption: [{
        name: '非常满意',
        value: 1
      }, {
        name: '满意',
        value: 2
      }, {
        name: '不满意',
        value: 3
      }, {
        name: '非常不满意',
        value: 4
      }],
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.statueOption = [];
      this.childData = {};
      this.loadAdStatue();

      if (true) {
        fetchDetail({
          id: this.keyValue,
          flowNum: this.flowNum
        }).then(function (res) {
          if (res.data.code === 200) {
            _this.childData = res.data.data;
          }
        });
      }
    },
    loadAdStatue: function loadAdStatue() {
      var _this2 = this;

      fetchListByType('evaluation_criterion').then(function (r) {
        _this2.statueOption = r.data.data;
      });
    },
    // 隐藏大部分字符串
    splideStr: function splideStr(str, length) {
      if (str !== null && str !== undefined) {
        if (str.length >= length) {
          return str.substring(0, length - 1) + '...';
        } else {
          return str;
        }
      }
    },
    handEvaluate: function handEvaluate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.keyValue > 0) {
            _this3.childData.feebackId = _this3.keyValue;
            fetchUpdate(_this3.childData).then(function () {
              _this3.$emit('handCancle', 'repairEvaluate');

              _this3.Alert({
                alertType: 'update'
              });
            });
          } else {
            _this3.Alert({
              alertType: 'valid'
            });
          }
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle');
    }
  }
};